import { ApprovingInvoiceReportPaymentInfoResponse } from 'ap-openapi';
import { useEffect, useMemo } from 'react';
import {
  ActiveFileType,
  TAB_KEYS,
  usePaymentDetail,
} from '@/components/InvoiceReportDetailDrawer/context/PaymentDetailContext';
import { useFirstInvoiceFileSelection } from '@/components/InvoiceReportDetailDrawer/hooks/useInvoiceFiles';

export const useDataChangeReset = (
  data: ApprovingInvoiceReportPaymentInfoResponse | undefined
) => {
  const { selectFirstInvoiceFile } = useFirstInvoiceFileSelection(data);
  useEffect(() => {
    selectFirstInvoiceFile();
  }, [selectFirstInvoiceFile]);
};

export const useMfFileId = () => {
  const { activeTab, activeFile } = usePaymentDetail();

  // Handle mfFileId logic - for business documents use fileId, for invoices use id
  const mfFileId = useMemo(() => {
    if (
      activeFile &&
      ((activeTab === TAB_KEYS.ATTACHED_INVOICE &&
        activeFile.type === ActiveFileType.INVOICE) ||
        (activeTab === TAB_KEYS.TRANSACTION_DOCUMENTS &&
          activeFile.type === ActiveFileType.BUSINESS_DOCUMENT))
    ) {
      // For business documents, use fileId if available, otherwise fallback to id
      // For invoices, use id directly
      return activeFile.type === ActiveFileType.BUSINESS_DOCUMENT
        ? activeFile.fileId || activeFile.id
        : activeFile.id;
    }
    return undefined;
  }, [activeTab, activeFile]);

  return mfFileId;
};
